import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as ExclamationIcon } from "assets/images/icons/Exclamation.svg";
import "./Alert.scss";

interface IAlertProps {
  variant?: string;
  children?: React.ReactNode;
  className?: string;
  isLoading?: boolean;
  iconClass?: string;
  noIcon?: boolean;
}

const Alert = function ({
  variant = "",
  children,
  className = "",
  isLoading = false,
  iconClass = "mr-3",
  noIcon = false,
  ...props
}: IAlertProps) {
  return (
    <div className="d-flex">
      <div {...props} data-testid="alert" className={`${className} custom-alert custom-alert-${variant}`}>
        {isLoading ? (
          <div className="spinner-border spinner-border-sm mr-3" role="status" />
        ) : (
          <div>
            {!noIcon && <ExclamationIcon className={`custom-alert-${variant}-icon ${iconClass}`} style={{ minWidth: 16 }} />}
          </div>
        )}

        <span className="font-b2">{children}</span>
      </div>
    </div>
  );
};

Alert.propTypes = {
  variant: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  iconClass: PropTypes.string,
};

Alert.defaultProps = {
  variant: "",
  children: "",
  className: "",
  isLoading: false,
  iconClass: undefined,
  noIcon: false,
};

export default Alert;
